<template>
  <div class="pa-4">
    <v-card-title>Website Builder</v-card-title>
    <v-card-text>
      <v-card>
        <v-card-text>
          <iframe :src="website" height="300px" width="100%"></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="goToWebsite()" color="primary">
            <v-icon class="mr-1">mdi-monitor-edit</v-icon>
            EDIT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card-text>
  </div>
</template>

<script>

export default {
  data() {
    return {
      website: "https://d2d29uu13ujp9j.cloudfront.net/untitled-m7idh8ny?preview=67bbc9b50d302c00081d0ca1%230001&__locale=en-US&__tenant=root",
    };
  },
  components: {
  },
  created() {
  },
  watch: {},
  methods: {
    goToWebsite() {
      window.open('https://dsheus71bsynz.cloudfront.net/')
    }
  }
};
</script>

<style scoped></style>